module.exports = __webpack_public_path__ + "img/slider-6.e9b0fb23.jpg";